export enum StatePreschool {
  StatePreschoolContractor = 1,
  StatePreschoolSubcontractor = 2
}
